<!-- Template -->

<template>
    <div>
        <Header/>

        <TopNavigation :path="path"/>

        <section id="main-container">
            <div class="login-form">
                <ValidationObserver ref="validation" v-slot="{ invalid }">
                    <form>
                        <div class="title">
                            <h3>Login</h3>
                        </div>

                        <!-- Notification -->

                        <FormNotification is-error :message="error"/>

                        <!-- Email -->
                        <div class="form-group">
                            <ValidationProvider
                                name="email"
                                rules="required|email"
                                v-slot="{ errors }"
                            >
                                <div :class="{'is-error': errors.length }">
                                    <label>Email</label>
                                    <input
                                        autofocus
                                        type="email"
                                        placeholder="email@address.com"
                                        v-model="email"
                                        class="form-control"
                                    >
                                    <span class="error-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                        </div>
                        <!-- Password -->
                        <div class="form-group">
                            <ValidationProvider
                                name="password"
                                vid="password"
                                rules="required|min:6"
                                v-slot="{ errors }"
                            >
                                <div :class="{'is-error': errors.length }">
                                    <label>Password</label>
                                    <input type="password" v-model="password" class="form-control">
                                    <span class="error-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                        </div>
                        <!-- Buttons -->

                        <div class="submit">
                            <button
                                type="submit"
                                class="btn-large btn-blue btn-block"
                                :disabled="invalid || isProcessing"
                                @click.prevent="onSubmit"
                            >
                                <span v-if="!isProcessing">Sign in</span>
                                <span v-if="isProcessing" class="spinner-border"></span>
                            </button>
                        </div>

                        <router-link :to="{ name: 'RemindPassword' }">Can't log in?</router-link>
                    </form>
                </ValidationObserver>
            </div>
        </section>
        <Footer/>
    </div>
</template>

<!-- Script -->

<script>
    import Header from "@/components/Header";
    import Footer from "@/components/Footer";
    import TopNavigation from "@/components/TopNavigation";
    import { ValidationProvider, ValidationObserver } from "vee-validate";
    import { PageMessage } from "@/models/page-message";
    import { AccountService } from "@/services/account-service";
    import FormNotification from "@/components/Login/FormNotification";

    export default {
        name: "Login",

        components: {
            Header,
            Footer,
            TopNavigation,
            ValidationProvider,
            ValidationObserver,
            FormNotification
        },

        data() {
            return {
                email: "",
                password: "",
                isProcessing: false,
                redirectTo: null,
                error: new PageMessage(),
                path:[]
            };
        },

        computed: {
            validator() {
                return this.$refs.validation;
            }
        },

        created() {
            this.accountService = new AccountService(this.$api, this.$store);
            this.redirectTo = this.$route.query.redirectTo;
        },

        methods: {
            async onSubmit() {
                const isValid = await this.validator.validate();
                if (!isValid) return;

                this.isProcessing = true;
                this.error.reset();

                try {
                    await this.accountService.login(this.email, this.password);

                    if (this.redirectTo) {
                        this.$router.push(this.redirectTo);
                    } else {
                        this.$router.push({ name: "Hospitals" });
                    }
                } catch (error) {
                    this.error.setError(error);
                } finally {
                    this.isProcessing = false;
                }
            }
        }
    };
</script>

<!-- Style -->


<style scoped lang="scss" src="@/styles/pages/_login.scss" />